module.exports = __webpack_public_path__ + "static/media/Face_attribute_analysis@2x.f4927943.png";